import Exception from './Exception';
export default class NotSupportedException extends Exception {
    constructor(message, innerException) {
        if (innerException) {
            super(message, innerException);
        }
        else {
            if (message) {
                super(message);
            }
            else {
                super();
            }
        }
        this.name = 'NotSupportedException';
    }
}
